import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { useState } from 'react';
import styled from 'styled-components';
import copyTextToClipboard from '@uiw/copy-to-clipboard';
import { CopyIcon, RightIcon } from './Icon';
import { GlobalStyle } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n  background-color: transparent;\n  opacity: 0;\n  transition: 0.3s all;\n"])));
var Warpper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  border: 1px solid var(--color-border-result-code);\n  border-radius: 5px;\n  display: flex;\n  min-height: 31px;\n  transition: 0.3s transform;\n  &:hover {\n    transform: scale(1.01);\n  }\n  &:hover ", " {\n    opacity: 1;\n  }\n"])), Button);
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 6px 8px;\n  word-break: break-all;\n"])));
var Label = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 5px;\n  border-right: 1px solid var(--color-border-result-code);\n  min-width: 32px;\n"])));
export var CodeLineCopyTitle = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n  padding-bottom: 6px;\n  margin-bottom: 6px;\n  border-bottom: 1px dashed var(--color-border-result-code);\n"])));
export var CodeLineCopy = _ref => {
  var {
    blockCopy = true,
    copyBtn = true,
    copyText,
    title,
    label,
    children
  } = _ref;
  var [success, setSuccess] = useState(false);
  function handleClick() {
    copyTextToClipboard("" + (copyText || children), () => {
      setSuccess(true);
      var timer = setTimeout(() => {
        setSuccess(false);
        clearTimeout(timer);
      }, 3000);
    });
  }
  var props = {};
  if (blockCopy && copyBtn) {
    props.onClick = handleClick;
    props.style = {
      cursor: 'pointer'
    };
  }
  return /*#__PURE__*/_jsxs(Warpper, _extends({}, props, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), label && /*#__PURE__*/_jsx(Label, {
      children: label
    }), /*#__PURE__*/_jsxs(Content, {
      children: [title && /*#__PURE__*/_jsx(CodeLineCopyTitle, {
        children: title
      }), children]
    }), copyBtn && /*#__PURE__*/_jsx(Button, {
      onClick: handleClick,
      style: success ? {
        color: '#4caf50'
      } : {},
      children: success ? /*#__PURE__*/_jsx(RightIcon, {
        width: 19,
        height: 19
      }) : /*#__PURE__*/_jsx(CopyIcon, {
        width: 19,
        height: 19
      })
    })]
  }));
};